import React from "react";

import {Loader} from "@pg-design/loader-module";

import * as styles from "./ListLoader.module.css";

export const ListLoader = () => {
    return (
        <div className={styles.listLoader}>
            <Loader size="md" />
        </div>
    );
};
import React from "react";

import {Loader} from "@pg-design/loader-module";

import * as styles from "./ListLoader.module.css";

export const ListLoader = () => {
    return (
        <div className={styles.listLoader}>
            <Loader size="md" />
        </div>
    );
};
